export default "/images/ad_inspiration_img.png?1d21249c60a02c0606e30f34b7bec58a";